import { Sheet } from 'src/components';

import { Typography } from '@remarkable/ark-web';
import { AppPage } from 'src/components/AppPage';
import { GeneratedUsers } from './components/GeneratedUsers';
import { UserPropertiesForm } from './components/UserPropertiesForm';

export const TestDataApp = () => {
  return (
    <AppPage.Container className="max-w-l2xl">
      <AppPage.Header
        title="Test data generator"
        subtitle="Create user accounts for development and testing"
      />
      <AppPage.Content className="w-full">
        <div className="flex flex-col gap-24 ll:flex-row">
          <div className="w-full ll:max-w-ls">
            <Sheet className="sticky top-0">
              <Typography as="h2" variant="heading-lg">
                Create user
              </Typography>
              <UserPropertiesForm />
            </Sheet>
          </div>

          <GeneratedUsers />
        </div>
      </AppPage.Content>
    </AppPage.Container>
  );
};
